import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getAllCampaigns, getUserCampaigns, postCampaign, updateCampaign, deleteCampaign } from '../services/Campaigns.ts';
import { Campaign } from '../types/index.ts';
import { toast } from 'react-hot-toast';

export const useCampaigns = (userId?: string) => {
    return useQuery({
        queryKey: ['campaigns', userId],
        queryFn: async () => {
            if (userId) {
                const response = await getUserCampaigns(undefined, userId);
                return response?.data;
            }
            const response = await getAllCampaigns();
            return response?.data;
        },
        // enabled: true // Always enabled, logic inside handles userId presence
    });
};

export const useCreateCampaign = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: Partial<Campaign>) => postCampaign(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['campaigns'] });
            toast.success('Campaign created successfully');
        },
        onError: (error: any) => {
            toast.error(error.message || 'Failed to create campaign');
        },
    });
};

export const useUpdateCampaign = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: Partial<Campaign> }) => updateCampaign(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['campaigns'] });
            toast.success('Campaign updated successfully');
        },
        onError: (error: any) => {
            toast.error(error.message || 'Failed to update campaign');
        },
    });
};

export const useDeleteCampaign = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => deleteCampaign(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['campaigns'] });
            toast.success('Campaign deleted successfully');
        },
        onError: (error: any) => {
            toast.error(error.message || 'Failed to delete campaign');
        },
    });
};
